import _ from 'lodash';

// Function to gather all values for each key
export function getAllValuesForKey(obj: object | object[], valuesMap = new Map()) {
  // If the object is not an array, go through its keys
  if (_.isObject(obj) && !_.isArray(obj)) {
    _.forEach(obj, (value, key) => {
      if (!valuesMap.has(key)) {
        valuesMap.set(key, []); // Create an array for each key if it doesn't exist
      }
      valuesMap.get(key).push(value); // Add the current value to the corresponding key's array
    });
  }

  // Recursively explore all values in arrays and objects
  _.forEach(obj, (value) => {
    if (_.isObject(value) && !_.isArray(value)) {
      getAllValuesForKey(value, valuesMap); // Recurse into objects
    } else if (_.isArray(value)) {
      _.forEach(value, (item) => {
        if (_.isObject(item)) {
          getAllValuesForKey(item, valuesMap); // Recurse into array elements if they are objects
        }
      });
    }
  });

  // Convert Map to a plain object with string[] arrays
  const result: Record<string, any[]> = {};
  valuesMap.forEach((value, key) => {
    result[key] = _.uniq(value); // Remove duplicates from the array
  });

  return result;
}
